import { render } from "./UserLocationList.vue?vue&type=template&id=062b0348&ts=true"
import script from "./UserLocationList.vue?vue&type=script&lang=ts"
export * from "./UserLocationList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__